import type { ReactNode } from 'react'
import { inLanguage } from '../../language/text.js'
import type { SingleProps } from './kinds.js'

/**
 * Verwijzen naar een persoon, organisatie of dossier: `lookup`.
 *
 * **Bewust een lege plek en geen half werkende zoeker.** Wat een lookup moet doen is
 * zoeken in het CRM of in de dossiers van de gastheer, en die koppeling loopt via de
 * gastheerzijde of een centrale integratiedienst, nooit rechtstreeks vanuit de
 * browser (B14, R-53). Er is in M2 geen kanaal om iets op te zoeken, dus een
 * zoekveld zou een leeg resultaat opleveren dat als storing overkomt.
 *
 * Wat er wel staat is de gekozen waarde alleen-lezen, zodat een voorgevulde lookup
 * (R-37) en een lookup in een alleen-lezen weergave kloppen. Het zoeken zelf komt
 * met de vaste componenten en de gastheerkoppeling (M7, M8).
 */
export function Lookup({ veld: field, taal: language, koppeling: link, waarde: value }: SingleProps): ReactNode {
  return (
    <p className="ef-opzoeken" id={link.id} aria-describedby={link['aria-describedby']}>
      {value === undefined || value === null || value === '' ? (
        <span className="ef-opzoeken__leeg">
          {language === 'nl'
            ? // Geen "gastheer" en geen "versie" (audit van 30 oktober 2026): de invuller kent die
              // woorden niet. Wel dat er niets van hem wordt gevraagd.
              'Opzoeken is nog niet beschikbaar. Hier hoeft nu niets ingevuld te worden.'
            : 'Look-up is not available yet. Nothing needs to be filled in here for now.'}
        </span>
      ) : (
        <span>{String(value)}</span>
      )}
      <span className="ef-sr-only">
        {field.label === undefined ? field.control : inLanguage(field.label, language)}
      </span>
    </p>
  )
}
